import { gql } from "@apollo/client";


export const GET_NOTIFICATION_SETTINGS = gql`
query NotificationSettingsOne {
  settings: NotificationSettingsOne {
    notification
  }
}
`

export const SAVE_NOTIFICATION_SETTINGS = gql`
mutation NotificationSettingsSaveOne($record: NotificationSettingsSaveOneInput!) {
  NotificationSettingsSaveOne(record: $record) {
    notification
  }
}
`
